import React from "react";
import moment from "moment";
import TodayIcon from "@material-ui/icons/Today";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { useSelector } from "react-redux";
import { makeStyles, Grid, Divider } from "@material-ui/core";
import { Typography } from "@packages/ui";
import _ from "lodash";


const useStyles = makeStyles((theme) => ({
  root: {
    padding: 15,
    backgroundColor: `#f0f0f0`,
  },
  headerFont: {
    fontSize: 12,
    fontWeight: 800,
    color: "black",
  },
  icon: {
    marginTop: 3,
    marginLeft: -2,
    fontSize: 22,
    color: "black",
  },
}));

const BookingDetailHeader = () => {
  const classes = useStyles();
  const checkin = useSelector((state) => ({ ...state.checkin }));

  return (
    <div>
    <Grid container direction="row" justify="center" alignItems="center" spacing={24} className={classes.root}>
    <Grid item xs={6} md={3} lg={2}>
        <Typography className={classes.headerFont}>Reservation Number</Typography>
        <Typography>
          {checkin?.resNo}
        </Typography>
    </Grid>
    <Grid item lg={2}></Grid>
    <Grid item xs={6} md={3} lg={2} style={{ textAlign: "right" }}>
      <Typography className={classes.headerFont}>Confirmation Number</Typography>
        <Typography>
          {_.isEmpty(checkin.confNo) ? "---" : checkin.confNo}
        </Typography>
    </Grid>
    </Grid>
    <Divider variant="fullWidth" />
    <Grid container direction="row" justify="center" alignItems="center" spacing={24} className={classes.root}>
      <Grid item xs={6} md={3} lg={2}>
        <Typography className={classes.headerFont}>PICK-UP</Typography>
        <Typography>
          {checkin?.details?.Pickup ? _.get(checkin,'details.Pickup[0].locationName',"--") : ""}
        </Typography>
        <Grid container direction="row">
          <Grid item xs={2}>
            <TodayIcon className={classes.icon} />
          </Grid>
          <Grid item xs={10}>
            {moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
              "DD-MM-YY"
            )}
          </Grid>
        </Grid>
        <Grid container direction="row">
          <Grid item xs={2}>
            <AccessTimeIcon className={classes.icon} />
          </Grid>
          <Grid item xs={10}>
            {moment(checkin?.reservation?.Pickup?.dateTime, "YYYY-MM-DDTh:mm:ss").format("H:mm")}
          </Grid>
        </Grid>
      </Grid>
      <Grid item lg={2}></Grid>
      <Grid item xs={6} md={3} lg={2} style={{ textAlign: "right" }}>
        <Typography className={classes.headerFont}>RETURN</Typography>
        <Typography>
          {checkin.details.Return ? _.get(checkin,'details.Return[0].locationName',"--") : ""}
        </Typography>
        <Grid container direction="row">
          <Grid item xs={10}>
            {moment(checkin?.reservation?.Return?.dateTime, "YYYY-MM-DDTh:mm:ss").format(
              "DD-MM-YY"
            )}
          </Grid>
          <Grid item xs={2}>
            <TodayIcon className={classes.icon} />
          </Grid>
        </Grid>
        <Grid container direction="row">
          <Grid item xs={10}>
            {moment(checkin?.reservation?.Return?.dateTime, "YYYY-MM-DDTh:mm:ss").format("H:mm")}
          </Grid>
          <Grid item xs={2}>
            <AccessTimeIcon className={classes.icon} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    </div> 
  );
};

export default BookingDetailHeader;
